Object.defineProperty(exports, "__esModule", { value: true });
exports.blogModelConfig = void 0;
const core_1 = require("@wheelroom/core");
exports.blogModelConfig = {
    blog: {
        fields: {
            heading: {
                type: 'shortText',
            },
            abstract: {
                type: 'longText',
            },
            media: {
                type: 'media',
            },
            icon: {
                items: core_1.featherIconNames,
                type: 'dropdown',
            },
            slug: {
                initialContent: 'initial-content-for-slug',
                required: true,
                type: 'shortText',
                typePostfix: 'Slug',
                unique: true,
            },
            date: {
                required: true,
                type: 'date',
            },
            text: {
                required: true,
                type: 'richText',
            },
            categories: {
                type: 'tags',
            },
            authors: {
                allowedComponents: ['topic'],
                type: 'multipleComponents',
            },
            seoTitle: {
                type: 'shortText',
            },
            seoDescription: {
                maxLength: 155,
                type: 'shortText',
            },
            seoImage: {
                type: 'media',
                typePostfix: 'Image',
            },
            seoKeywords: {
                type: 'tags',
            },
        },
        modelVersion: '1.0.0',
        settings: {
            asFragment: true,
            asQuery: 'subPage',
        },
    },
    blogSection: {
        fields: {
            variation: {
                items: ['blog', 'list'],
                type: 'dropdown',
            },
            eventId: {
                type: 'shortText',
                initialContent: 'initial-content-for-blog-section-event-id',
                typePostfix: 'Slug',
                helpText: 'Example: my-event-id',
                unique: true,
            },
        },
        modelVersion: '1.0.0',
        settings: {
            asBoilerplate: false,
            asFragment: true,
            asPageSection: true,
        },
    },
};
//# sourceMappingURL=blog-model-config.js.map